const BET_TOURNAMENTS_FEATURE_KEY = "betTournaments";
const betTournamentTermId = "bettors-tournament";
var BetTournamentBoardColor = /* @__PURE__ */ ((BetTournamentBoardColor2) => {
  BetTournamentBoardColor2[BetTournamentBoardColor2["none"] = 0] = "none";
  BetTournamentBoardColor2[BetTournamentBoardColor2["gold"] = 1] = "gold";
  BetTournamentBoardColor2[BetTournamentBoardColor2["silver"] = 2] = "silver";
  BetTournamentBoardColor2[BetTournamentBoardColor2["bronze"] = 3] = "bronze";
  return BetTournamentBoardColor2;
})(BetTournamentBoardColor || {});
var BetTournamentParticipationStatus = /* @__PURE__ */ ((BetTournamentParticipationStatus2) => {
  BetTournamentParticipationStatus2[BetTournamentParticipationStatus2["auto"] = 0] = "auto";
  BetTournamentParticipationStatus2[BetTournamentParticipationStatus2["manual"] = 1] = "manual";
  return BetTournamentParticipationStatus2;
})(BetTournamentParticipationStatus || {});
var BetTournamentUserParticipationStatus = /* @__PURE__ */ ((BetTournamentUserParticipationStatus2) => {
  BetTournamentUserParticipationStatus2[BetTournamentUserParticipationStatus2["agreed"] = 1] = "agreed";
  BetTournamentUserParticipationStatus2[BetTournamentUserParticipationStatus2["disagreed"] = 2] = "disagreed";
  BetTournamentUserParticipationStatus2[BetTournamentUserParticipationStatus2["unselected"] = 3] = "unselected";
  return BetTournamentUserParticipationStatus2;
})(BetTournamentUserParticipationStatus || {});
const BetTournamentEnumToColor = {
  [
    0
    /* none */
  ]: "none",
  [
    1
    /* gold */
  ]: "gold",
  [
    2
    /* silver */
  ]: "silver",
  [
    3
    /* bronze */
  ]: "bronze"
};
var BetTournamentTemplates = /* @__PURE__ */ ((BetTournamentTemplates2) => {
  BetTournamentTemplates2[BetTournamentTemplates2["MultiBoard"] = 1] = "MultiBoard";
  BetTournamentTemplates2[BetTournamentTemplates2["SingleBoard"] = 2] = "SingleBoard";
  return BetTournamentTemplates2;
})(BetTournamentTemplates || {});
var BetTournamentStrategies = /* @__PURE__ */ ((BetTournamentStrategies2) => {
  BetTournamentStrategies2[BetTournamentStrategies2["WinBets"] = 1] = "WinBets";
  BetTournamentStrategies2[BetTournamentStrategies2["SettledBets"] = 2] = "SettledBets";
  return BetTournamentStrategies2;
})(BetTournamentStrategies || {});
export {
  BET_TOURNAMENTS_FEATURE_KEY,
  BetTournamentBoardColor,
  BetTournamentEnumToColor,
  BetTournamentParticipationStatus,
  BetTournamentStrategies,
  BetTournamentTemplates,
  BetTournamentUserParticipationStatus,
  betTournamentTermId
};
